var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSharingDesktopAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8083 4.68061C10.6464 4.40001 10.7425 4.04123 11.023 3.87924L12.5649 3.10555C12.8454 2.94356 13.2043 3.03968 13.3662 3.32027C13.5282 3.60087 13.4321 3.95966 13.1515 4.12165L11.6097 4.89533C11.3291 5.05733 10.9702 4.96121 10.8083 4.68061Z",
    fill: "#0E72ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2121 7.75802C11.2121 7.49027 11.4292 7.27317 11.697 7.27317H13.8788C14.1466 7.27317 14.3636 7.49027 14.3636 7.75802C14.3636 8.02578 14.1466 8.24287 13.8788 8.24287H11.697C11.4292 8.24287 11.2121 8.02578 11.2121 7.75802Z",
    fill: "#0E72ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6097 10.539C11.3291 10.377 10.9702 10.4731 10.8083 10.7537C10.6464 11.0343 10.7425 11.393 11.023 11.555L12.5649 12.4105C12.8454 12.5725 13.2043 12.4764 13.3662 12.1958C13.5282 11.9152 13.4321 11.5564 13.1515 11.3944L11.6097 10.539Z",
    fill: "#0E72ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72727 5.33323C2.32561 5.33323 2 5.65884 2 6.0605V9.93923C2 10.3409 2.32561 10.6665 2.72727 10.6665H4.21961C4.35343 10.6665 4.48466 10.7034 4.59885 10.7732L7.68137 12.657C8.16599 12.9531 8.78788 12.6044 8.78788 12.0364V3.96329C8.78788 3.39534 8.16599 3.04656 7.68137 3.34272L4.59885 5.22652C4.48466 5.29631 4.35343 5.33323 4.21961 5.33323H2.72727Z",
    fill: "#0E72ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharingDesktopAudio);
export default __webpack_public_path__ + "static/media/sharing-desktop-audio.0085d0eb3d4107602941ea29dedb2a6b.svg";
export { ForwardRef as ReactComponent };